"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.packageDependencies = void 0;
var _lodash = require("@avantia/lodash");
var _packageVersion = require("./packageVersion");
const packageDependencies = {
  name: 'loggingAndErrors',
  version: _packageVersion.packageVersion,
  dependencies: {
    lodash: _lodash.packageVersion
  }
};
exports.packageDependencies = packageDependencies;